import type { NextPage } from "next"
import { useRouter } from "next/router"

import CustomRichText from "~/components/CustomRichText"
import { FormalLayout, TitledSection } from "~/components/FormalLayout"
import { SEO } from "~/components/SEO"
import { withoutFalsyValues } from "~/utils/withoutFalsyValues"

import type { CookiesSectionProps } from "./CookiesSection"
import { CookiesSection } from "./CookiesSection"

export type SimpleSection = {
  type: "section"
  title: {
    id: string
    text: string
  }
  body: prismic.RichTextField
}

export type CookieSection = {
  type: "cookies_info"
} & CookiesSectionProps

export type PrivacyPolicyProps = {
  title: string
  sections: (SimpleSection | CookieSection)[]
}

export const PrivacyPolicyPage: NextPage<PrivacyPolicyProps> = ({
  title,
  sections,
}) => {
  const { pathname } = useRouter()
  const sectionTitles = withoutFalsyValues(
    sections.map((item) => (item.type === "section" ? item.title : null)),
  )

  return (
    <>
      <SEO pageTitle={title} path={pathname} />
      <FormalLayout title={title} sectionTitles={sectionTitles}>
        {sections.map((item, index) => {
          switch (item.type) {
            case "section": {
              const { id, text: sectionTitle } = item.title

              return (
                <TitledSection key={id} id={id} title={sectionTitle}>
                  <CustomRichText field={item.body} />
                </TitledSection>
              )
            }

            case "cookies_info": {
              return <CookiesSection key={index} {...item} />
            }

            default:
              return null
          }
        })}
      </FormalLayout>
    </>
  )
}
